import { useEffect, useState } from "react";
import { deleteContent, getContents, signInWithEmail, updateContent } from "../../FIREBASECONFIG";

export const useResortsUsersQuery = (collectionName) => {
  const [resortsUsers, setResortsUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const loadUsers = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await getContents(collectionName);
        if (isMounted) {
          setResortsUsers(data || []);
        }
      } catch (err) {
        if (isMounted) setError(err);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    loadUsers();

    return () => {
      isMounted = false;
    };
  }, []);

  return {
    resortsUsers,
    loading,
    error,
    refetch: () => getContents(collectionName),
  };
};

export const useResortUserMutation = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const createResortsUser = async (userData) => {
    setLoading(true);
    setError(null);
    try {
      await signInWithEmail(
        userData.email,
        userData.password,
        userData.name,
        userData.role,
        userData.city || userData.City
      );
      setLoading(false);
      return true;
    } catch (err) {
      setError(err);
      setLoading(false);
      console.error("Error creating resort user:", err);
      return false;
    }
  };

  const updateResortsUser = async (userId, userData) => {
    setLoading(true);
    setError(null);
    try {
      const updateData = {
        name: userData.name,
        email: userData.email,
        role: userData.role,
        city: userData.city || userData.City,
      };

      // Only include password if it's provided
      if (userData.password && userData.password.trim()) {
        updateData.password = userData.password;
      }

      await updateContent("users", "", userId, updateData);
      setLoading(false);
      return true;
    } catch (err) {
      setError(err);
      setLoading(false);
      console.error("Error updating resort user:", err);
      return false;
    }
  };

  return {
    createResortsUser,
    updateResortsUser,
    loading,
    error,
  };
};

export const useDeleteResortUserMutation = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const deleteResortUser = async (userId) => {
    setLoading(true);
    setError(null);

    try {
      await deleteContent("users", userId);
      setLoading(false);
      return true;
    } catch (err) {
      setError(err);
      setLoading(false);
      return false;
    }
  };

  return { deleteResortUser, loading, error };
}